import React, {Component} from 'react';

import PaginationComponent from "../../../../component/table/Pagination";
import ImageAddModal from "../component/ImageAddModal";
import Alert from "../../../../component/modal/Alert";

import * as apiUtil from '../../../../util/apiUtil';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as imageAction from "../store/image";

import './ImageSearchEngine.css'
import Loading from "../../../../component/loading/Loading";

class ImageListContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.ajaxGetImageList = this.ajaxGetImageList.bind(this);
        this.ajaxImageUpload = this.ajaxImageUpload.bind(this);
        this.ajaxImageDelete = this.ajaxImageDelete.bind(this);

        this.setValue = this.setValue.bind(this);

        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        this.handleModal = this.handleModal.bind(this);

        this.openAlert = this.openAlert.bind(this);
        this.closeAlert = this.closeAlert.bind(this);

        this.state = {
            loading: false,

            alertOpen: false,
            alertMessage: '',
            alertButtons: [],

            openModal: false,
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.openModal !== nextState.openModal
            || this.props.imageType !== nextProps.imageType
            || this.props.sortBy !== nextProps.sortBy
            || this.props.page !== nextProps.page
            || this.props.size !== nextProps.size
            || this.props.total !== nextProps.total
            || this.props.imageDeleteUidList !== nextProps.imageDeleteUidList
            || this.props.images !== nextProps.images
            || this.props.imgFile !== nextProps.imgFile
            || this.props.imgName !== nextProps.imgName

            || this.state.alertOpen !== nextState.alertOpen
            || this.state.alertMessage !== nextState.alertMessage
            || this.state.alertButtons !== nextState.alertButtons
        )
    }

    componentDidMount() {
        this.ajaxGetImageList();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    ajaxGetImageList() {
        const { sortBy, imageType, page, size } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/list",
            method: apiUtil.requestMethod.POST,
            data: {
                imgType: imageType,
                sort: sortBy,
                page: page,
                size: size,
            },
            success: (result) => {
                const { ImageAction } = this.props;
                ImageAction.setImages(result.content);
                ImageAction.setTotal(result.total);
                ImageAction.setImageDeleteUidList([]);
            }
        })
    }

    ajaxImageUpload() {
        if (! window.confirm("이미지를 등록하시겠습니까?")) return;

        const { imageType, imgName, imgFile } = this.props;

        let data = new FormData();
        data.append("type", imageType);
        data.append("name", imgName);
        data.append("file", imgFile);

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/upload",
            method: apiUtil.requestMethod.POST,
            isFile: true,
            data: data,
            success: (result) => {
                this.openAlert(
                    "이미지를 등록하였습니다.",
                    [
                        { onClick: function () {window.location.reload();},  label: "확인", className: "btn btn-primary" }
                    ]
                )
            }
        })
    }

    ajaxImageDelete() {
        const { imageDeleteUidList, imageType } = this.props;

        if (imageDeleteUidList.length === 0) {
            alert("삭제할 이미지가 선택되지 않았습니다.");
            return;
        }

        if (! window.confirm("선택한 이미지를 삭제하시겠습니까?")) return;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/image/delete",
            method: apiUtil.requestMethod.POST,
            data: {
                imgType: imageType,
                imgUidList: imageDeleteUidList
            },
            success: (result) => {
                this.openAlert(
                    "이미지를 삭제하였습니다.",
                    [
                        { onClick: function () {window.location.reload();},  label: "확인", className: "btn btn-primary" }
                    ]
                )
            }
        })
    }

    async handleTypeChange(event) {
        const { ImageAction } = this.props;
        const value = event.target.value;
        await ImageAction.setImageType(value);
        await ImageAction.setPage(1);

        this.ajaxGetImageList();
    }

    async handleSort(event) {
        const { ImageAction } = this.props;
        const value = event.target.value;
        await ImageAction.setSortBy(value);
        await ImageAction.setPage(1);

        this.ajaxGetImageList();
    }

    async handlePageChange(event, value) {
        const { ImageAction } = this.props;
        await ImageAction.setPage(value);

        this.ajaxGetImageList();
    }

    handleModal() {
        const { openModal } = this.state;
        this.setState({ openModal: ! openModal });

        const {ImageAction} = this.props;
        ImageAction.resetImgUploadParams();
    }

    handleCheckboxChange(uid) {
        const { ImageAction, imageDeleteUidList } = this.props;

        let uidArray = imageDeleteUidList;
        if (imageDeleteUidList.indexOf(uid) > -1) {
            uidArray = imageDeleteUidList.filter((item) => item !== uid);
        } else {
            uidArray.push(uid);
        }

        ImageAction.setImageDeleteUidList(uidArray);
    }

    setValue(id, value) {
        const { ImageAction } = this.props;

        switch (id) {
            case "imgFile":
                ImageAction.setImgFile(value);
                break;
            case "imgName":
                ImageAction.setImgName(value);
                break;
            default:
                break;
        }
    }

    openAlert(message, buttons) {
        this.setState({ alertOpen: true, alertMessage: message, alertButtons: buttons });
    }

    closeAlert() {
        const { alertOpen } = this.state;
        this.setState({ alertOpen: ! alertOpen });
    }

    render() {
        const { loading } = this.state;

        const { openModal } = this.state;
        const { total, images, size, imageType } = this.props;
        const {imgName } = this.props;

        const { setValue } = this;
        const { handleTypeChange, handleSort, handlePageChange, handleCheckboxChange } = this;
        const { handleModal, ajaxImageUpload, ajaxImageDelete } = this;

        const { alertOpen, alertMessage, alertButtons } = this.state;
        const { closeAlert } = this;

        return (
            <>
                <Loading loading={loading}/>
                <div className='container-xxl pb-3'>
                    <h2 className='fs-4'>이미지 관리</h2>

                    <div className='info-content-item shadow'>
                        <h5 className='d-flex align-items-center'>
                            <span className="material-symbols-outlined text-primary fs-4 pe-2 fw-bold">report</span>
                            <span>이미지 관리</span>
                        </h5>
                        <ol className='fs-6 mb-0 fw-normal fs-4 ps-3 ps-sm-5 '>
                            <li>셀프 메시지 등록 시 활용되는 이미지를 관리할 수 있습니다.</li>
                            <li>이미지는 최대 1년까지 저장되며, 1년이 지난 이미지는 자동 삭제됩니다.</li>
                            <li>RCS 이미지는 기존형 400×240 또는 500×300, T형 900×800, M형 900×500 규격으로 등록 가능합니다.</li>
                            <li>이미지 유형은 jpg, jpeg 유형만 등록 및 발송 가능합니다.</li>
                            <li>등록하시는 이미지는 발송 시 가독성을 고려하여 100KB 이상 용량으로 등록 부탁드립니다.</li>
                        </ol>
                    </div>
                    <ul className="img-search nav nav-tabs fs-5">
                        <li className="nav-item">
                            <input
                                className='d-none'
                                type="radio"
                                name="imageTarget"
                                id="imageType1"
                                value="MMS"
                                onChange={handleTypeChange}
                            />
                            <label
                                className={`nav-link form-check-label ${imageType === "MMS" ? "active" : ""}`}
                                htmlFor="imageType1"
                                data-toggle="tab"
                            >
                                문자 메시지
                            </label>
                        </li>
                        <li className="nav-item">
                            <input
                                className='d-none'
                                type="radio"
                                name="imageTarget"
                                id="imageType2"
                                value="RCS"
                                onChange={handleTypeChange}
                                defaultChecked={true}
                            />
                            <label
                                className={`nav-link form-check-label ${imageType === "RCS" ? "active" : ""}`}
                                htmlFor="imageType2"
                                data-toggle="tab"
                            >
                                RCS
                            </label>
                        </li>
                    </ul>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row mb-1'>
                                <div className='w-50'>
                                    <div className='pb-2'>
                                        <select className='form-select d-inline w-auto' name="sort" id="" onChange={handleSort}>
                                            <option value="date" defaultValue={true}>최신 등록순</option>
                                            <option value="name" >이름 순</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='w-50'>
                                    <div className={"text-end"}>
                                        <button className='btn btn-primary ms-0 ms-lg-2' onClick={handleModal}>추가</button>
                                        <button className='btn btn-danger ms-2' onClick={ajaxImageDelete}>삭제
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="d-grid mb-2">
                                {
                                    images.map((image, index) => (
                                        <div key={index} className='grid-item'>
                                            <div key={image.uid} className={"card border"}>
                                                <div className="card-header ellipsis-text">
                                                    <input id={`checkbox-${index}`} className='form-check-input me-2 pointer' type="checkbox" onClick={() => handleCheckboxChange(image.uid)}/>
                                                    <label htmlFor={`checkbox-${index}`} className='d-inline pointer fs-5'>{image.imgName}</label>
                                                </div>
                                                <div className="card-body">
                                                    <img src={image.imgUrl} alt="이미지 사진"/>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <PaginationComponent total={total} sizePerPage={size} handleChange={handlePageChange}/>
                        </div>
                    </div>
                </div>
                <ImageAddModal
                    isOpen={openModal}
                    handleClose={handleModal}
                    setValue={setValue}
                    imgUploadAction={ajaxImageUpload}
                    imgType={imageType}
                    imgName={imgName}
                />
                <Alert
                    isOpen={alertOpen}
                    handleClose={closeAlert}
                    message={alertMessage}
                    buttons={alertButtons}
                />
            </>
        )
    }
}

export default connect(
    (state) => ({
        imageType: state.image.get('imageType'),
        sortBy: state.image.get('sortBy'),
        page: state.image.get('page'),
        size: state.image.get('size'),

        total: state.image.get('total'),
        images: state.image.get('images'),

        imageDeleteUidList: state.image.get('imageDeleteUidList'),

        imgFile: state.image.get('imgFile'),
        imgName: state.image.get('imgName'),
    }),
    (dispatch) => ({
        ImageAction: bindActionCreators(imageAction, dispatch),
    })
)(ImageListContainer);
